/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ScanMetadata } from './ScanMetadata';
export type Scan = {
    /**
     * Unique ID of this measurement.
     */
    measurementID: string;
    /**
     * Unique ID of the session this scan belongs to.
     */
    sessionID: string;
    /**
     * Unique ID of the company this scan belongs to.
     */
    companyID: string;
    /**
     * Is this a complete scan?
     */
    isComplete: boolean;
    /**
     * Scan subtype.
     */
    subtype: Scan.subtype;
    /**
     * Operator of the scanning device.
     */
    operator?: string;
    /**
     * Scan metadata.
     */
    meta?: ScanMetadata;
};
export namespace Scan {
    /**
     * Scan subtype.
     */
    export enum subtype {
        SCAN_SUBTYPE_FLAT_LEFT_FOOT = 'SCAN_SUBTYPE_FLAT_LEFT_FOOT',
        SCAN_SUBTYPE_FLAT_RIGHT_FOOT = 'SCAN_SUBTYPE_FLAT_RIGHT_FOOT',
    }
}

